module.exports = __webpack_public_path__ + "static/img/006.eeeedc16.png";